var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomatorSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 36,
    rx: 2.5,
    fill: "#EF7707",
    fillOpacity: 0.15,
    stroke: "url(#paint0_linear_7092_6054)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7092_6054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7092_6054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 28.5C17.95 28.5 17.0625 28.1375 16.3375 27.4125C15.6125 26.6875 15.25 25.8 15.25 24.75C15.25 23.8833 15.5083 23.1208 16.025 22.4625C16.5417 21.8042 17.2 21.3583 18 21.125V19H12V15H9.5V8H16.5V15H14V17H24V14.875C23.2 14.6417 22.5417 14.1958 22.025 13.5375C21.5083 12.8792 21.25 12.1167 21.25 11.25C21.25 10.2 21.6125 9.3125 22.3375 8.5875C23.0625 7.8625 23.95 7.5 25 7.5C26.05 7.5 26.9375 7.8625 27.6625 8.5875C28.3875 9.3125 28.75 10.2 28.75 11.25C28.75 12.1167 28.4917 12.8792 27.975 13.5375C27.4583 14.1958 26.8 14.6417 26 14.875V19H20V21.125C20.8 21.3583 21.4583 21.8042 21.975 22.4625C22.4917 23.1208 22.75 23.8833 22.75 24.75C22.75 25.8 22.3875 26.6875 21.6625 27.4125C20.9375 28.1375 20.05 28.5 19 28.5ZM25 13C25.4833 13 25.8958 12.8292 26.2375 12.4875C26.5792 12.1458 26.75 11.7333 26.75 11.25C26.75 10.7667 26.5792 10.3542 26.2375 10.0125C25.8958 9.67083 25.4833 9.5 25 9.5C24.5167 9.5 24.1042 9.67083 23.7625 10.0125C23.4208 10.3542 23.25 10.7667 23.25 11.25C23.25 11.7333 23.4208 12.1458 23.7625 12.4875C24.1042 12.8292 24.5167 13 25 13ZM11.5 13H14.5V10H11.5V13ZM19 26.5C19.4833 26.5 19.8958 26.3292 20.2375 25.9875C20.5792 25.6458 20.75 25.2333 20.75 24.75C20.75 24.2667 20.5792 23.8542 20.2375 23.5125C19.8958 23.1708 19.4833 23 19 23C18.5167 23 18.1042 23.1708 17.7625 23.5125C17.4208 23.8542 17.25 24.2667 17.25 24.75C17.25 25.2333 17.4208 25.6458 17.7625 25.9875C18.1042 26.3292 18.5167 26.5 19 26.5Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7092_6054",
    x1: 19,
    y1: 0,
    x2: 19,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD7409"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatorSettings);
export default __webpack_public_path__ + "static/media/automatorSettings.a19d78137a66e6b23213de907649af49.svg";
export { ForwardRef as ReactComponent };